import { useTranslation } from 'react-i18next';
import { Lightbulb } from 'lucide-react';
import { simulateCashFlow } from './dealCalc';

export default function ScoreImprovement({ deal }) {
  const { t } = useTranslation();
  const cur = deal.monthly_cash_flow;
  const items = [];

  if (deal.suggested_offer_price < deal.purchase_price) {
    items.push({ key: 'price', label: t('decision.buyAtTarget'), impact: simulateCashFlow(deal, { purchase_price: deal.suggested_offer_price }) - cur });
  }
  items.push({ key: 'rent', label: t('decision.increaseRent5'), impact: simulateCashFlow(deal, { annual_income: deal.annual_income * 1.05 }) - cur });

  if (deal.interest_rate > 1) {
    items.push({ key: 'rate', label: t('decision.lowerRate05'), impact: simulateCashFlow(deal, { interest_rate: deal.interest_rate - 0.5 }) - cur });
  }
  if (deal.vacancy_rate > 2) {
    items.push({ key: 'vac', label: t('decision.lowerVacancy'), impact: simulateCashFlow(deal, { vacancy_rate: deal.vacancy_rate - 2 }) - cur });
  }
  items.push({
    key: 'exp', label: t('decision.reduceExpenses'),
    impact: simulateCashFlow(deal, { monthly_maintenance: (deal.monthly_maintenance || 0) * 0.9, annual_property_tax: (deal.annual_property_tax || 0) * 0.9 }) - cur,
  });

  const positive = items.filter(i => i.impact > 0).sort((a, b) => b.impact - a.impact);
  if (!positive.length) return null;
  const max = positive[0].impact;

  return (
    <div data-testid="score-improvement" className="bg-white dark:bg-[#0F1419] border border-slate-200 dark:border-white/[0.06] rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Lightbulb className="w-4 h-4 text-amber-500" />
        <h3 className="font-semibold text-sm text-slate-900 dark:text-white">{t('decision.scoreImprovement')}</h3>
      </div>
      <div className="space-y-3">
        {positive.map((item, i) => (
          <div key={item.key} className="flex items-center gap-3">
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-slate-600 dark:text-slate-300">{item.label}</span>
                <span className="text-xs font-bold text-emerald-500 tabular-nums">+${Math.round(item.impact).toLocaleString()}{t('decision.perMonth')}</span>
              </div>
              <div className="h-1.5 bg-slate-100 dark:bg-white/[0.06] rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-emerald-500 to-emerald-400 rounded-full transition-all duration-500"
                  style={{ width: `${(item.impact / max) * 100}%` }} />
              </div>
            </div>
            {i === 0 && (
              <span className="px-1.5 py-0.5 text-[9px] font-bold rounded bg-emerald-500/10 text-emerald-500 flex-shrink-0 whitespace-nowrap">
                {t('decision.highestImpact')}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
